import React from "react";

export default function Header() {
  return (
    <div className="title-container">
      <h1 className="main-title">Create your QR Code</h1>
    </div>
  );
}
